module.exports = __webpack_public_path__ + "media/images/athletes/3529-fde865a71205b85a98c741cae7fc8840.png";